/**
 * Lesson helper utilities
 */

/**
 * Determines if a lesson is online based on its location field
 *
 * Online indicators:
 * - Contains "online", "zoom", "meet", "teams", "virtual"
 * - Contains a URL (http/https)
 * - Empty location (defaults to online)
 *
 * @param location - The lesson location string
 * @returns true if lesson is online, false if in-person
 */
export function isLessonOnline(location: string | undefined | null): boolean {
  // Default to online if no location specified
  if (!location || location.trim() === '') {
    return true
  }

  const locationLower = location.toLowerCase().trim()

  // Check for online indicators
  const onlineKeywords = [
    'online',
    'zoom',
    'meet',
    'teams',
    'virtual',
    'skype',
    'webex',
    'google meet',
    'microsoft teams',
  ]

  // Check if location contains any online keyword
  if (onlineKeywords.some((keyword) => locationLower.includes(keyword))) {
    return true
  }

  // Check if location is a URL
  if (
    locationLower.startsWith('http://') ||
    locationLower.startsWith('https://') ||
    locationLower.includes('zoom.us') ||
    locationLower.includes('meet.google.com') ||
    locationLower.includes('teams.microsoft.com')
  ) {
    return true
  }

  // Otherwise, assume it's a physical location (in-person)
  return false
}
